import React, { CSSProperties, MutableRefObject } from "react";
import classname from "classnames";

type ButtonType = "close" | "previous" | "next";

interface Props {
  type: ButtonType;
  ariaLabel: string;
  mobileTopPosition?: number;
  clickHandler?: () => void;
  buttonRef?: MutableRefObject<HTMLButtonElement>;
}

const IconButton: React.FC<Props> = ({
  ariaLabel,
  clickHandler,
  mobileTopPosition,
  type,
  buttonRef,
}) => {
  const classes = classname("lightbox__icon-button", {
    "lightbox__icon-close": type === "close",
    "lightbox__navigation-button": type !== "close",
    "lightbox__icon-prev": type === "previous",
    "lightbox__icon-next": type === "next",
  });

  const iconClose = (
    <svg className="lightbox__icon" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path d="m24 21.88 7.425-7.426 2.121 2.121L26.121 24l7.425 7.425-2.121 2.121L24 26.121l-7.425 7.425-2.121-2.12L21.879 24l-7.425-7.425 2.121-2.12L24 21.878Z" />
    </svg>
  );

  const iconArrowRight = (
    <svg className="lightbox__icon" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.061 16L12.111 11.05L13.525 9.63599L19.889 16L13.525 22.364L12.111 20.95L17.061 16Z" />
    </svg>
  );

  return (
    <button
      ref={buttonRef}
      className={classes}
      type="button"
      onClick={clickHandler}
      aria-label={ariaLabel}
      style={
        !mobileTopPosition
          ? null
          : ({
              "--top-position": `${mobileTopPosition}px`,
            } as CSSProperties)
      }
    >
      {type === "close" ? iconClose : iconArrowRight}
    </button>
  );
};

export default IconButton;
